'use client'

import { LineBed } from '@qr-front/icons/line-bed'
import { LineCafe } from '@qr-front/icons/line-cafe'
import { LineDog } from '@qr-front/icons/line-dog'
import { LineRestaurant } from '@qr-front/icons/line-restaurant'
import { LineSeat } from '@qr-front/icons/line-seat'
import { LineTaxi } from '@qr-front/icons/line-taxi'
import { LineTrain } from '@qr-front/icons/line-train'
import { LineWc } from '@qr-front/icons/line-wc'
import { LineWheelchair } from '@qr-front/icons/line-wheelchair'
import { LineWifi } from '@qr-front/icons/line-wifi'
import { useTranslations } from 'next-intl'

import { LineBar } from './Icons/LineBar'
import { LineChild } from './Icons/LineChild'
import { LineParking } from './Icons/LineParking'

export const FACILITIES_ICONS = {
	LineWifi,
	LineTrain,
	LineSeat,
	LineTaxi,
	LineWheelchair,
	LineBed,
	LineWc,
	LineCafe,
	LineChild,
	LineBar,
	LineDog,
	LineRestaurant,
	LineParking,
}

type FacilityConfig = {
	id: string
	icon: keyof typeof FACILITIES_ICONS
	translationKey: string
}

export const FACILITY_CONFIG: FacilityConfig[] = [
	{
		id: 'wifi',
		icon: 'LineWifi',
		translationKey: 'generator__content_form_section__facilities__wi-fi',
	},
	{
		id: 'train',
		icon: 'LineTrain',
		translationKey: 'generator__content_form_section__facilities__train',
	},
	{
		id: 'seat',
		icon: 'LineSeat',
		translationKey: 'generator__content_form_section__facilities__seating',
	},
	{
		id: 'taxi',
		icon: 'LineTaxi',
		translationKey: 'generator__content_form_section__facilities__taxi',
	},
	{
		id: 'accessible',
		icon: 'LineWheelchair',
		translationKey: 'generator__content_form_section__facilities__accessible',
	},
	{
		id: 'bed',
		icon: 'LineBed',
		translationKey: 'generator__content_form_section__facilities__accomodation',
	},
	{
		id: 'toilet',
		icon: 'LineWc',
		translationKey: 'generator__content_form_section__facilities__toilet',
	},
	{
		id: 'cafe',
		icon: 'LineCafe',
		translationKey: 'generator__content_form_section__facilities__coffee',
	},
	{
		id: 'child',
		icon: 'LineChild',
		translationKey:
			'generator__content_form_section__facilities__child_friendly',
	},
	{
		id: 'bar',
		icon: 'LineBar',
		translationKey: 'generator__content_form_section__facilities__bar',
	},
	{
		id: 'petFriendly',
		icon: 'LineDog',
		translationKey: 'generator__content_form_section__facilities__pet_friendly',
	},
	{
		id: 'restaurant',
		icon: 'LineRestaurant',
		translationKey: 'generator__content_form_section__facilities__restaurant',
	},
	{
		id: 'parking',
		icon: 'LineParking',
		translationKey: 'generator__content_form_section__facilities__parking',
	},
]

export const FACILITIES_LIST = () => {
	const t = useTranslations()

	return FACILITY_CONFIG.map((facility) => {
		const Icon = FACILITIES_ICONS[facility.icon]

		return {
			id: facility.id,
			icon: Icon,
			name: t(facility.translationKey),
		}
	})
}

export type TFacility = keyof typeof FACILITIES_ICONS
